import type { ConnectionType } from '~/features/onboarding/types/connection.types';

import type { AnalyticsWorkflowStatus } from './types/analytics-sync.types';

/**
 * Connector codes whose connections feed the experiment lift dashboards AND are
 * accepted by the `POST analytics/sync` dispatch matrix. GA4 sessions, Google
 * Ads performance, and GMC catalog. Note `GA4_ANALYTICS` is intentionally
 * excluded — the dispatch matrix only supports `GA4_REPORTING` and would 400.
 */
export const ANALYTICS_SYNC_SOURCES: readonly ConnectionType[] = [
  'GA4_REPORTING',
  'GOOGLE_ADS',
  'GOOGLE_MERCHANT',
] as const;

/** Workflow statuses that mean the run is finished — stop polling on any of these. */
const TERMINAL_STATUSES: ReadonlySet<AnalyticsWorkflowStatus> = new Set([
  'COMPLETED',
  'FAILED',
  'CANCELLED',
]);

/** True once a workflow has reached a terminal state (drives poll-stop + toast finalisation). */
export function isTerminalStatus(status: AnalyticsWorkflowStatus | undefined): boolean {
  return status !== undefined && TERMINAL_STATUSES.has(status);
}

/** True when the terminal run failed or was cancelled (drives the error vs success toast). */
export function isFailedStatus(status: AnalyticsWorkflowStatus): boolean {
  return status === 'FAILED' || status === 'CANCELLED';
}
